import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BlockPluckingReport } from './Pages';

export const BlockPluckingReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={BlockPluckingReport} />
       
    </Fragment>
)